<script lang="ts" setup>
import { computed } from 'vue'
import { useBatchSort } from './useBatchSort'

const { currentSortLabel, currentSortIcon, menuItems, toggleSort } = useBatchSort()

const dropdownItems = computed(() =>
  menuItems.value.map((item) => ({
    text: item.text,
    icon: item.icon,
    onClick: () => toggleSort(item.field),
  })),
)
</script>

<template>
  <div>
    <v-menu
      :close-on-content-click="true"
      max-height="90vh"
      offset-y
      rounded="xl"
      transition="slide-y-transition"
    >
      <template #activator="{ on: menu }">
        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <vs-button
              :label="currentSortLabel"
              data-test="invoice-sort-dropdown-button"
              :icon="currentSortIcon"
              small
              type="secondary"
              v-on="{ ...tooltip, ...menu }"
            />
          </template>
          <span>Sort Columns</span>
        </v-tooltip>
      </template>

      <v-list class="invoice-sort-dropdown__list">
        <v-list-item v-for="item in dropdownItems" :key="item.text" @click="item.onClick">
          <v-list-item-content>
            <v-list-item-title class="invoice-sort-dropdown__item-title">{{
              item.text
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="ml-2">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped>
.invoice-sort-dropdown__list {
  width: max-content;
  max-width: 320px;
}

.invoice-sort-dropdown__item-title {
  white-space: normal;
  line-height: 1.3;
}
</style>
